export const styles = (theme) => ({
  root: {
    height: '100%',
    [theme.breakpoints.only('xl')]: {
      width: 237,
    },
  },
  header: {
    padding: theme.spacing(1.5, 2),
  },
  section: {
    padding: theme.spacing(1.5, 2),
  },
  label: {
    marginBottom: theme.spacing(0.5),
  },
  value: {
    wordBreak: 'break-word',
    marginBottom: theme.spacing(1.5),
    '&:last-child': {
      marginBottom: 0,
    },
  },
});
